// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"756":"f46c370e","807":"08aea9cd","893":"4ae1b4e4"}[chunkId] + ".css";
};